// extracted by mini-css-extract-plugin
export var attention = "h_v";
export var button = "h_m";
export var disabled = "h_x";
export var icon = "h_p";
export var primary = "h_r";
export var save = "h_w";
export var secondary = "h_s";
export var text = "h_q";
export var white = "h_t";
export var withoutText = "h_n";